<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ICQlGH/tc-custom/9781611210026.jpg?1706273757939" alt="This image is the cover for the book Russian Officer Corps of the Revolutionary and Napoleonic Wars"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Russian Officer Corps of the Revolutionary and Napoleonic Wars
      </h1>
      <p class="bookDescription body article font2">
        <b><i>The Russian Officer Corps of The Revolutionary and Napoleonic Wars, 1795–1815</i></b><b> features more than 800 detailed biographies of the commanders of that era.</b><br/>  <br/><b>Foreword by Professor Donald H. Horward, Institute on Napoleon and the French Revolution, Florida State University</b><br/>  <br/> Based upon years of research in Russian archives, historian Alexander Mikaberidze’s biographies include the subject’s place of birth, family history, educational background, a detailed description of his military service, his awards and promotions, wounds, transfers, commands, and other related information, including the date and place of his death and internment, if known. In addition, an introductory chapter presents in meticulous detail the organization of the Russian military, how it was trained, the educational and cultural background of the officer corps, its awards and their history and meaning, and much more. This outstanding overview is supported and enhanced by three dozen charts, tables, and graphics that illustrate the rich history of the Russian officer corps. This study also includes an annotated bibliography to help guide students of the period through the available Russian sources.<br/>  <br/> Stunning in its scope and depth of coverage, <i>The Russian Officer Corps</i> is essential reading for historians, scholars, genealogists, hobbyists, war gamers, and anyone working or studying late eighteenth and early nineteenth-century European history. Every student of the Revolutionary and Napoleonic Wars, as well as every academic library, will find this impressive reference work of this momentous period of history absolutely indispensable. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alexander Mikaberidze
      </h2>
      
      <p class="authorDescription body article">Alexander Mikaberidze is an assistant professor of history at Mississippi State University. He holds a law degree from the Republic of Georgia and a Ph.D. in history from Florida State University, where he worked at the Institute on Napoleon and the French Revolution. He serves as president of the Napoleonic Society of Georgia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Savas Beatie
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4da79d8c